import { render, staticRenderFns } from "./Single_term.vue?vue&type=template&id=34944225&scoped=true"
import script from "./Single_term.vue?vue&type=script&lang=js"
export * from "./Single_term.vue?vue&type=script&lang=js"
import style0 from "./Single_term.vue?vue&type=style&index=0&id=34944225&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34944225",
  null
  
)

export default component.exports